export const REG_STATION_NUMBER_KEY = 'regStationNumber';
